module.exports = __webpack_public_path__ + "media/packs/images/panes/attentions-5aee3d2328a242c1703578a36b7ad340.svg";